import React from 'react';

import cs from 'classnames';
import styled from 'styled-components';

interface Props {
  active: boolean;
  disabled?: boolean;
  onClick: (ev: React.SyntheticEvent<unknown>) => unknown;
  className?: string;
  children: React.ReactNode;
}

export const DocumentMetadataStatusButton = React.forwardRef<
  HTMLButtonElement,
  Props
>(
  (
    {className, onClick, children, active, disabled = false, ...other}: Props,
    forwardedRef: React.ForwardedRef<HTMLButtonElement>
  ): JSX.Element => {
    const clickHandler = (e: React.SyntheticEvent<any>) => {
      e.stopPropagation();
      onClick(e);
    };

    return (
      <StyledButton
        {...other}
        className={cs('btn btn-sm btn-light', className, {
          active,
          disabled,
          'text-secondary': !active,
        })}
        onClick={disabled ? undefined : clickHandler}
        ref={forwardedRef}
      >
        {children}
      </StyledButton>
    );
  }
);

const StyledButton = styled.button`
  background: none !important;
  padding: 0.125rem 0.4rem;

  &.active {
    background-color: #e8e8e8 !important;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.125) !important;
  }

  &.disabled {
    opacity: 0.75;
    border-color: #dadada;
  }
`;
